var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1909_13072",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1909_13072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 13.9L7.10078 18.8C6.91745 18.9834 6.68411 19.075 6.40078 19.075C6.11745 19.075 5.88411 18.9834 5.70078 18.8C5.51745 18.6167 5.42578 18.3834 5.42578 18.1C5.42578 17.8167 5.51745 17.5834 5.70078 17.4L10.6008 12.5L5.70078 7.60005C5.51745 7.41672 5.42578 7.18338 5.42578 6.90005C5.42578 6.61672 5.51745 6.38338 5.70078 6.20005C5.88411 6.01672 6.11745 5.92505 6.40078 5.92505C6.68411 5.92505 6.91745 6.01672 7.10078 6.20005L12.0008 11.1L16.9008 6.20005C17.0841 6.01672 17.3174 5.92505 17.6008 5.92505C17.8841 5.92505 18.1174 6.01672 18.3008 6.20005C18.4841 6.38338 18.5758 6.61672 18.5758 6.90005C18.5758 7.18338 18.4841 7.41672 18.3008 7.60005L13.4008 12.5L18.3008 17.4C18.4841 17.5834 18.5758 17.8167 18.5758 18.1C18.5758 18.3834 18.4841 18.6167 18.3008 18.8C18.1174 18.9834 17.8841 19.075 17.6008 19.075C17.3174 19.075 17.0841 18.9834 16.9008 18.8L12.0008 13.9Z",
    fill: "#454E58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3d41715284d947624dd944bb6ba82095.svg";
export { ForwardRef as ReactComponent };